export default {
  current_theme(state) {
    return state.current_theme;
  },

  default_theme(state) {
    return state.default_theme;
  },
};
